import MultiplePlaylistsAddModal from './MultiplePlaylistsAddModal'

export default MultiplePlaylistsAddModal
// eslint-disable-next-line import/export
export * from './MultiplePlaylistsAddModal'
